export default __webpack_public_path__ + "static/media/info-img.32f9471e.jpg";